import { createReducer, on } from '@ngrx/store';
import { AdminBlacklistInfo } from '../_interfaces/admin-blacklist-info.interface';
import { AdminKycAll, AdminKycError } from '../_interfaces/admin-kyc.interface';
import { FailedRegistration } from '../_interfaces/failed-registration.interface';
import * as adminActions from './kyc.actions';

export interface KycState {
    adminKycAll: AdminKycAll[] | null;
    adminKycErrors: AdminKycError[] | null;
    failedRegList: FailedRegistration[] | null;
    loading: boolean;
    kycRecords: AdminKycAll[];
    kycErrors: AdminKycError[];
    kycErrorsNoId: AdminKycError[];
    selectedKyc: AdminKycAll | AdminKycError;
    kycRecordsPage: number;
    kycRecordsPageSize: number;
    kycRecordsTotalCount: number;
    kycErrorsPage: number;
    kycErrorsPageSize: number;
    kycErrorsTotalCount: number;
    kycErrorsNoIdPage: number;
    kycErrorsNoIdPageSize: number;
    kycErrorsNoIdTotalCount: number;
    adminBlacklistInfo: AdminBlacklistInfo[] | null;
}

export const initialState: KycState = {
    adminKycAll: null,
    adminKycErrors: null,
    failedRegList: null,
    loading: false,
    kycRecords: null,
    kycErrors: null,
    kycErrorsNoId: null,
    selectedKyc: null,
    kycRecordsPage: 1,
    kycRecordsPageSize: 5,
    kycRecordsTotalCount: 0,
    kycErrorsPage: 1,
    kycErrorsPageSize: 5,
    kycErrorsTotalCount: 0,
    kycErrorsNoIdPage: 1,
    kycErrorsNoIdPageSize: 5,
    kycErrorsNoIdTotalCount: 0,
    adminBlacklistInfo: null
};

export const _kycReducer = createReducer(initialState,

    on(adminActions.setAdminKycAll, (state: KycState, { adminKycAll }) => ({
        ...state, adminKycAll
    })),

    on(adminActions.setAdminKycErrors, (state: KycState, { adminKycErrors }) => ({
        ...state, adminKycErrors
    })),

    on(adminActions.fetchKycRecords, (state) => ({
        ...state, loading: true
    })),

    on(adminActions.fetchKycRecordsSuccess, (state, { kycRecords, kycRecordsPage, kycRecordsPageSize, kycRecordsTotalCount }) => ({
        ...state, loading: false, kycRecords, kycRecordsPage, kycRecordsPageSize, kycRecordsTotalCount
    })),

    on(adminActions.fetchKycRecordsFailed, (state) => ({
        ...state, loading: false
    })),

    on(adminActions.fetchKycErrors, (state) => ({
        ...state, loading: true
    })),

    on(adminActions.fetchKycErrorsSuccess, (state, { kycErrors, kycErrorsPage, kycErrorsPageSize, kycErrorsTotalCount }) => ({
        ...state, loading: false, kycErrors, kycErrorsPage, kycErrorsPageSize, kycErrorsTotalCount
    })),

    on(adminActions.fetchKycRecordsFailed, (state) => ({
        ...state, loading: false
    })),

    on(adminActions.fetchKycErrorsNoId, (state) => ({
        ...state, loading: true
    })),

    on(adminActions.fetchKycErrorsNoIdSuccess, (state,{ kycErrorsNoId, kycErrorsNoIdPage, kycErrorsNoIdPageSize, kycErrorsNoIdTotalCount }) => ({
        ...state, loading: false, kycErrorsNoId, kycErrorsNoIdPage, kycErrorsNoIdPageSize, kycErrorsNoIdTotalCount
    } )),

    on(adminActions.fetchKycErrorsNoIdFailed, (state) => ({
        ...state, loading: false
    })),

    on(adminActions.setFailedUserRegistration, (state, { failedReg }) => ({
        ...state, failedRegList : failedReg
    })),

    on(adminActions.setBlacklistInfoList, (state, { blacklistInfos }) => ({
        ...state, adminBlacklistInfo : blacklistInfos
    }))
);

export const kycReducer = (state: KycState, action) => _kycReducer(state, action);
